import {JacksonType, JsonSubType} from "@sonner/jackson-service-v2";
import {Papel} from "./papel";
import {PerfilEnum} from "../enums/perfil.enum";

@JacksonType("Administrador")
@JsonSubType({key: 'br.com.sonner.iss.entity.Administrador', type: "Papel"})
export class Administrador extends Papel {

  constructor() {
    super(PerfilEnum.administrador);
  }
}
